import { Alert, Col, Divider, Form, Input, Row, Typography } from "antd";
import { FunctionComponent, useCallback, useContext } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import ActionBtn from "../../shared/action-btn";
import getErrorMessage from "../../shared/get-error-msg";
import uDayjs from "../../shared/uDayjs";
import { AppContext } from "../contexts/app-context";
import HttpClient from "../http-client";

interface ProfilePageProps {}

const ProfilePage: FunctionComponent<ProfilePageProps> = () => {
  const { user, setUser, organization } = useContext(AppContext);
  const [busy, setBusy] = useStateIfMounted(false);
  const [serverMsg, setServerMsg] = useStateIfMounted<string | undefined>(
    undefined
  );
  const [serverMsgType, setServerMsgType] = useStateIfMounted<
    "error" | "success" | undefined
  >(undefined);
  const onFinish = useCallback(
    async (values: any) => {
      setBusy(true);
      setServerMsg(undefined);
      try {
        const { data } = await HttpClient.patch("user/update", values);

        if (data?.data) {
          setUser({ ...user, ...data.data });
          setServerMsgType("success");
          setServerMsg("Your profile is updated!");
          setTimeout(() => {
            setServerMsg(undefined);
          }, 2000);
        }
      } catch (error: any) {
        if (error?.response?.data?.error) {
          setServerMsgType("error");
          setServerMsg(getErrorMessage(error?.response?.data));
        }
      }

      setBusy(false);
    },
    [user]
  );
  return (
    <div className="profile-page">
      <Divider orientation="left" orientationMargin={0}>
        My Organization
      </Divider>
      <Row>
        <Col span={8}>
          <Typography.Text>
            <b>Name</b>
          </Typography.Text>
        </Col>
        <Col span={16}>
          <Typography.Text>{organization?.name}</Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Typography.Text>
            <b>Domain</b>
          </Typography.Text>
        </Col>
        <Col span={16}>
          <Typography.Text>{organization?.upn}</Typography.Text>
        </Col>
      </Row>
      <Divider orientation="left" orientationMargin={0}>
        My Data
      </Divider>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={user}
      >
        {serverMsg && (
          <Alert
            type={serverMsgType}
            message={serverMsg}
            style={{ marginBottom: 10 }}
          />
        )}
        <Form.Item label="Email">{user?.email}</Form.Item>
        <Form.Item label="Profile Status">{user?.user_status}</Form.Item>
        <Form.Item label="Role">{user?.role?.name ?? "---"}</Form.Item>

        {!!user?.created_at && (
          <Form.Item label="Joined At">
            {uDayjs(user?.created_at).format("DD/MM/YYYY hh:mma")}
          </Form.Item>
        )}
        {!!user?.updated_at && (
          <Form.Item label="Profile Updated At">
            {uDayjs(user?.updated_at).format("DD/MM/YYYY hh:mma")}
          </Form.Item>
        )}

        <Form.Item
          label="Name"
          name="name"
          rules={[{ message: "Please input your name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Update Password"
          name="new_password"
          rules={[{ message: "Please input your new password!" }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <ActionBtn type="primary" htmlType="submit" busy={busy}>
            Submit
          </ActionBtn>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ProfilePage;
